import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppointmentService } from '../../../../services/appointment.service';
import {
    CosnultationDataQuery,
    AppointmentClose,
} from '../../../../models/appointment';
import { Prescriptions } from '../../../../models//prescription';
import {
    PromiseResult,
    ApiResult
} from 'src/app/models/PromiseResult';
import { ConsultationData } from 'src/app/models/consultdoctors';
import { HttpErrorResponse } from '@angular/common/http';
import { PatientviewService } from '../../../../services/patientview/patientview.service';
import { MedicalHistoryService } from '../../../../services/medical-history.service';
import { medicalHistoryApiData } from '../../../../models/history';
import { TraceClassDecorator } from '@sentry/angular';
import { CONSULTATION_TYPES, URLS } from 'src/app/constant/constant';
import { SelectItem } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';
import { DefaultSlotsQuery, Schedule } from 'src/app/models/schedule';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { REG_EXP, OtpData } from 'src/app/models/util.models';
import { OtpInputComponent } from '../../otp-input/otp-input.component';
import { TokenService } from '../../../../utilities/token.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';


class PastPrescriptions extends Prescriptions {
    selected?= false;
}
@Component({
    selector: 'app-doctor-feedback',
    templateUrl: './doctor-feedback.component.html',
    styleUrls: [
        './doctor-feedback.component.css',
        '../../../../../assets/css/custom-egd.css'
    ],
})
@TraceClassDecorator()
export class DoctorFeedbackComponent implements OnInit {
    @Input('patient_guid')
    patient_guid = '';
    @Input('consultation_id')
    consultation_id = 0;
    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

    // @Input('consultation_type_id')
    // consultation_type_id = 0;
    @Output("appointment_success_close")
    appointment_success_close: EventEmitter<Event> = new EventEmitter<Event>();
    medicalHistoryApiData: medicalHistoryApiData = this.medicalHistoryService.init_medicalHistoryApiData();
    max_message_length_hci = 4000;
    max_message_length_cn = 10000;
    reg_exp: REG_EXP = new REG_EXP();
    is_primary_provider: boolean = false;
    is_uk_country: boolean = false;
    prescription: Prescriptions = new Prescriptions();
    past_prescriptions: PastPrescriptions[] = [];
    sendFeedBackData: AppointmentClose = new AppointmentClose();
    prescriptionlist: Prescriptions[] = [];
    data: CosnultationDataQuery = {
        user_guid: '',
        patient_guid: '',
        consultation_id: 0
    };
    isPassword: boolean = true;
    consultation_data: ConsultationData = new ConsultationData();
    user_guid: string;
    schedules: SelectItem[] = []
    query = new DefaultSlotsQuery();
    get_api_result: ApiResult = new ApiResult(true);
    post_api_result: ApiResult = new ApiResult(false);
    data1: OtpData = new OtpData();
    service_id = '';
    show_otp : boolean = false;
    userRoleId: number;
    constructor(
        private readonly AppointmentService: AppointmentService,
        private readonly patientViewService: PatientviewService,
        private readonly medicalHistoryService: MedicalHistoryService,
        private readonly scheduleService: ScheduleService,
        private readonly utilitiesService: UtilitiesService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly tokenUtil: TokenService,
        private readonly providerStateService: ProviderStateService
    ) { }

    async init() {
        this.consultation_data.patient_guid = this.patient_guid;
        this.consultation_data.consultation_id = this.consultation_id;
        this.is_primary_provider = this.providerStateService.getIsPrimaryProvider();
        if(URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        this.consultation_data.doctor_guid = sessionStorage.getItem('userid');
        this.data.patient_guid = this.consultation_data.patient_guid;
        this.data.user_guid = this.consultation_data.doctor_guid;
        this.data.consultation_id = this.consultation_data.consultation_id;
        this.sendFeedBackData.patient_guid = this.patient_guid;
        this.sendFeedBackData.consultation_id = this.consultation_id;
        this.show_otp = false;
        this.userRoleId = this.tokenUtil.findRoleId()
        // query.is_diet = true;
        await this.getPatientHistory();
        await this.fetchMedications();
        await this.getDefaultsTimings(this.consultation_data.patient_guid, this.consultation_data.consultation_id, this.query);
    }

    ngOnInit(): void {
    }

    async getPatientHistory() {
        this.get_api_result = new ApiResult(true);
        await this.AppointmentService.getCosnultationData(this.data)
            .toPromise()
            .then(result => {
                this.get_api_result.PromiseResult = result;
                if (result.success) {
                    this.consultation_data.consultation_type_id = result.data.consultation_type_id;
                    this.query.is_diet = this.consultation_data.consultation_type_id == 5;
                    this.consultation_data.consultations_left = result.data.consultations_left
                    this.sendFeedBackData.history_of_current_illness = result.data.d_consultation_data.history_of_current_illness || '';
                    this.sendFeedBackData.consultation_notes = result.data.d_consultation_data.consultation_notes || '';
                    this.prescriptionlist = result.data.p_prescriptions || [];
                    this.sendFeedBackData.issues = result.data.d_consultation_data.issues;
                    if (this.sendFeedBackData.issues != null)
                        this.sendFeedBackData.is_closed = false;
                } else {
                    this.get_api_result.ErrorModel = result.error;
                }
                this.get_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.get_api_result.PromiseResult.success = false;
                this.get_api_result.Posting = false;
                this.get_api_result.ServerError = error.error;
            });
    }

    set_otp_data(result: PromiseResult) {
        this.data1.OTP_validate_api.service_id = result.data.service_id;
        this.data1.OTP_validate_api.retry_after = new Date(result.data.retry_after);
    }

    async otpVerifySubmit() {
        if (this.sendFeedBackData.close_otp_checkbox) {
            this.data1.OTP_validate_api.retry = false;
            await this.getOTPdata();
            
        }
    }
    async getOTPdata() {
        this.data1.otp_api_result.Posting = true;
        this.data1.otp_Close_Case.patient_guid = this.patient_guid;
        this.data1.otp_Close_Case.consultation_id = this.consultation_id;
        await this.AppointmentService.otp_verify(this.consultation_data.doctor_guid, { ...this.data1.otp_Close_Case, ...this.data1.OTP_validate_api })
            .toPromise()
            .then(result => {
                this.data1.otp_api_result.PromiseResult = result;
                if (result.success) {
                    this.show_otp = true;
                    this.set_otp_data(result);
                    this.changeDetector.detectChanges();
                    this.OTP_Input.init_countdown();

                }
                this.data1.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.data1.otp_api_result.ServerError = error.error;
                this.data1.otp_api_result.PromiseResult.success = false;
                this.data1.otp_api_result.Posting = false;
            })
    }
    async otp_resend() {
        this.data1.OTP_validate_api.retry = true;
        await this.getOTPdata();
    }

    async getDefaultsTimings(patient_guid: string, consultation_id: number, query: DefaultSlotsQuery) {
        this.get_api_result = new ApiResult(true);
        this.schedules = [];

        await this.scheduleService.fetchDefault({
            patient_guid, consultation_id
        }, query).toPromise().then(result => {
            this.get_api_result.PromiseResult = result;

            if (result.success) {
                let schedules_result = result.data.slots;
                let temp_schedules: Schedule[] = [];

                for (let i = 0; i < schedules_result.length; i++) {
                    let a = new Date(schedules_result[i].slot_time).toDateString()
                    let b = new Date(schedules_result[i].slot_time).toTimeString()
                    let temp: Schedule = {
                        sr_no: i,
                        slot_id: schedules_result[i].slot_id,
                        slot_time: schedules_result[i].slot_time,
                        status: false,
                        date: a + " " + b,
                        block: false,
                    }
                    temp_schedules.push(temp);
                }
                this.schedules = this.utilitiesService.getSelectItemList(temp_schedules, "date", "slot_id", false);
            }
            else {
                this.get_api_result.ErrorModel = result.error;
            }

            this.get_api_result.Posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.get_api_result.PromiseResult.success = false;
            this.get_api_result.Posting = false;
            this.get_api_result.ServerError = error.error;
        });

    }

    add(prescription_type: number) {
        let prescription_ele: Prescriptions = {
            id: null,
            advice: null,
            comments: null,
            dosage: null,
            medication_name: null,
            no_of_refills: null,
            recommendations: null,
            times_per_day: null,
        }
        this.prescription.id = this.prescriptionlist.length;
        switch (prescription_type) {
            case 0:
                prescription_ele = {
                    id: this.prescription.id,
                    comments: this.prescription.comments,
                    dosage: this.prescription.dosage,
                    medication_name: this.prescription.medication_name,
                    no_of_refills: this.prescription.no_of_refills,
                    times_per_day: this.prescription.times_per_day,
                    advice: null,
                    recommendations: null,
                }

                break;
            case 1:
                prescription_ele = {
                    id: this.prescription.id,
                    comments: this.prescription.comments,
                    dosage: null,
                    medication_name: null,
                    no_of_refills: null,
                    times_per_day: null,
                    advice: this.prescription.advice,
                    recommendations: this.prescription.recommendations,
                }

                break;
            default:
                break;
        }
        this.prescriptionlist.push(prescription_ele);
        this.prescription = new Prescriptions();
    }

    async SaveData(event: Event) {
        this.post_api_result = new ApiResult(true);
        this.sendFeedBackData.prescriptions = this.prescriptionlist;
        this.sendFeedBackData.referred_to_specialty_id;
        // this.sendFeedBackData.otp_model.token = this.data1.OTP_validate_api.token;
        // this.sendFeedBackData.otp_model.service_id = this.data1.OTP_validate_api.service_id;
        this.sendFeedBackData.otp_model = { token: this.data1.OTP_validate_api.token, service_id: this.data1.OTP_validate_api.service_id };
        await this.AppointmentService.CloseAppointment(
            this.consultation_data.doctor_guid,
            this.sendFeedBackData
        )
            .toPromise()
            .then((result) => {
                this.post_api_result.PromiseResult = result;
                if (result.success) {
                    this.post_api_result.ErrorModel.message =
                        'Feedback Stored Successfully';
                    this.appointment_success_close.emit(event);
                } else {
                    this.post_api_result.ErrorModel = result.error;
                }
                this.post_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.get_api_result.Posting = false;
                this.post_api_result.Posting = false;
                this.post_api_result.PromiseResult.success = false;
                this.post_api_result.ServerError = error.error;
            });
    }

    async fetchMedications(): Promise<void> {
        this.get_api_result = new ApiResult(true);
        await this.patientViewService
            .fetchMedications(this.patient_guid)
            .toPromise()
            .then((result) => {
                this.get_api_result.PromiseResult = result;
                if (result.success) {
                    this.past_prescriptions = result.data.past_medications;
                }
                this.get_api_result.Posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.get_api_result.PromiseResult.success = false;
                this.get_api_result.Posting = false;
                this.get_api_result.ServerError = error.error;
            });
    }

    isDietConsultation(): boolean {
        return this.consultation_data.consultation_type_id == CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION;
    }



    addSelected() {
        this.past_prescriptions.forEach(e => {
            if (e.selected)
                this.prescriptionlist.push(
                    {
                        id: this.prescriptionlist.length,
                        medication_name: e.medication_name,
                        no_of_refills: 1,
                        dosage: e.dosage,
                        comments: e.comments,
                        times_per_day: e.times_per_day,
                        recommendations: e.recommendations || "",
                        advice: e.advice || "",
                    }
                )
        })
    }
    editPrescription(id: number, prescription_type: number): void {
        if (this.prescription.id != null) {
            this.add(prescription_type);
        }
        this.prescription = this.prescriptionlist[id];
        this.deletePrescription(id);
    }
    deletePrescription(id: number): void {
        this.prescriptionlist.splice(id, 1);
        this.fixID();
    }
    fixID(): void {
        let i = 0;
        this.prescriptionlist.forEach(e => {
            e.id = i++;
        });
    }

    isSuperAdmin() {
      return [3, 4].includes(this.userRoleId);
    }
}
